import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data || !props.documentId) return data

    return { ...data, document_id: Number(props.documentId) }
  }, [data, props.documentId])
}
